// Bridge module to break the circular dependency between
// NotificationService and the Redux store.
// store.ts sets the reference after creation; NotificationService reads it lazily.

let _store: any = null;

export function setStoreRef(store: any): void {
  _store = store;
}

export function getStoreRef(): any {
  return _store;
}
